module.exports = __webpack_public_path__ + "img/logo.750f06b4.webp";